module.exports = __webpack_public_path__ + "a7b8b36068b7f9cfbb53799c3b13123e.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/carousel/qello/1.png
// module id = 848
// module chunks = 0